import * as Yup from 'yup';
import { OTP_LENGTH } from '@/helpers/constants';

export const VALIDATION_SCHEMA = t =>
  Yup.object({
    code: Yup.string()
      .min(OTP_LENGTH, t('validation:invalid_varification_code'))
      .required(t('validation:required_varification_code')),
  });
